export default __webpack_public_path__ + "static/media/dv360-logo.05bd6bcf.svg";